import { $getStorage } from "@/common/common.js"

const getters = {
  user: (state) => state.user.user,
  location: (state) => state.location.location,
  cart: (state) => {
    if (Object.keys(state.cart.cart).length) {
      return state.cart.cart
    }
    state.cart.cart = Object.assign(state.cart.cart, $getStorage("cart"))
    return state.cart.cart
  },
}
export default getters
